import React, { useEffect, useState } from "react";
import {
    Table,
    Modal,
    Space,
    Tag,
    Popconfirm,
    message,
    Input,
    InputNumber,
    Select,
    Typography,
    Checkbox,
} from "antd";
import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
} from "@ant-design/icons";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import adminService from "@/services/admin.service";
import eventService from "@/services/event.service";
import InspectionBtn from "@/components/InspectionBtn";
import toast from "react-hot-toast";
 

const ReportManagement = () => {
    const [subscriptions, setSubscriptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [editingSubscription, setEditingSubscription] = useState(null);
    const [eventList, setAllEvents] = useState([])
    const [reportList, setReportList] = useState([])
    const { control, handleSubmit, reset } = useForm({

    });

    // Fetch subscriptions
    const fetchSubscriptions = async () => {
        setLoading(true);
        try {
            const res = await adminService.allreports();
            setSubscriptions(res.data);
        } catch (err) {
            toast.error("Failed to fetch subscriptions");
        }
        setLoading(false);
    };

    const getallEvents = async () => {
        const { data } = await eventService.getAllEvents();
        const eventsdetails = data?.map((x) => {
            return {
                label: x?.event_type,
                value: x?.id,
            };
        });
        setAllEvents(eventsdetails);

        const reportdata = await adminService.allreports();
        const reportlists = reportdata?.data?.map((x) => {
            return {
                label: x?.report_name,
                value: x?.report_name,
            };
        });
        setReportList(reportlists);

    }

    useEffect(() => {
        fetchSubscriptions();
        getallEvents()
    }, []);

    // Open modal for create / edit
    const openModal = (subscription = null) => {
        if (subscription) {
            setEditingSubscription(subscription);
            reset({
                ...subscription,
                events: subscription.events || [],
            });
        } else {
            setEditingSubscription(null);
            reset({
                name: "",
                max_users: 1,
                max_ships: 0,
                max_events: 0,

                events: [],
                reports: []
            });
        }
        setModalVisible(true);
    };
     // Submit form
    const onSubmit = async (data) => {
         try {
            const payload = {
                report_name: data?.report_name,
                event_list: data?.event_list?.map(x => {
                    const geteventinfo = eventList?.find(y => y?.value == x);
                     return {
                        label: geteventinfo?.label,
                        value: geteventinfo?.value
                    }
                })
            };
             if (editingSubscription) {
                await adminService.updateReport(data.report_id, payload);
                toast.success("Subscription updated");
            } else {
                await adminService.createReport(payload);
                toast.success("Subscription created");
            }
            fetchSubscriptions();
            setModalVisible(false);
        } catch (err) {
            toast.error("Failed to save subscription");
        }
    };

    // Delete
    const deleteSubscription = async (id) => {
        try {
            await adminService.deleteReport(id);
            toast.success("Subscription deleted");
            fetchSubscriptions();
        } catch (err) {
            toast.error("Failed to delete subscription");
        }
    };

    // Columns
    const columns = [
        { title: "Report Name", dataIndex: "report_name" },
        {
            title: "Events",
            dataIndex: "event_list",
            render: (events) =>
                events?.map((e, i) => (
                    <Tag key={i} color="green" className="mb-1">
                        {e?.label}
                    </Tag>
                )),
        },
   

        {
            title: "Actions",
            render: (_, record) => (
                <Space>
                    <InspectionBtn
                        icon={<EditOutlined />}
                        onClick={() => openModal(record)}
                        className="bg-blue-500 text-white"
                    >
                        Edit
                    </InspectionBtn>
                    <Popconfirm
                        title="Are you sure to delete this Report?"
                        onConfirm={() => deleteSubscription(record.id)}
                    >
                        <InspectionBtn
                            icon={<DeleteOutlined />}
                            danger
                            className="bg-red-500 text-white"
                        >
                            Delete
                        </InspectionBtn>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-4">
                <Typography.Title level={5} className=" font-bold">Report Management</Typography.Title>
                <InspectionBtn
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => openModal()}
                    className="bg-green-600"
                >
                    New Report
                </InspectionBtn>
            </div>

            <Table
                rowKey="id"
                dataSource={subscriptions}
                columns={columns}
                loading={loading}
                bordered
                className="spotflash-table"
            />

            {/* Modal with React Hook Form */}
            <Modal
                open={modalVisible}
                title={editingSubscription ? "Edit Report" : "New Report"}
                onCancel={() => setModalVisible(false)}
                onOk={handleSubmit(onSubmit)}
                okText="Save"
                className="rounded-xl"
            >
                <form className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium mb-1">Name</label>
                        <Controller
                            name="report_name"
                            control={control}
                            rules={{ required: "Name is required" }}
                            render={({ field }) => (
                                <Input {...field} placeholder="Enter subscription name" />
                            )}
                        />
                    </div>



                    <div>
                        <label className="block text-sm font-medium mb-1">Events</label>
                        <Controller
                            name="event_list"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    mode="tags"
                                    options={eventList}
                                    style={{ width: "100%" }}
                                    placeholder="Add or select events"
                                />
                            )}
                        />
                    </div>

                 

                </form>
            </Modal>
        </div>
    );
};

export default ReportManagement;
